var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInbox = function SvgInbox(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1_74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 512,
    width: 512,
    height: 512,
    rx: 110,
    transform: "rotate(-180 512 512)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1_74)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_1_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 154C90 127.49 111.49 106 138 106H375C401.51 106 423 127.49 423 154V353.263C423 379.773 401.51 401.263 375 401.263H138C111.49 401.263 90 379.773 90 353.263V154Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_iii_1_74)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.095 128.438C128.07 128.438 113.458 143.05 113.458 161.075V272.755C113.458 290.78 128.07 305.392 146.095 305.392H210.447C210.382 306.234 210.349 307.084 210.349 307.942V325.79C210.349 343.815 224.961 358.427 242.986 358.427H269.504C287.528 358.427 302.141 343.815 302.141 325.79V307.942C302.141 307.084 302.107 306.234 302.042 305.392H369.965C387.99 305.392 402.602 290.78 402.602 272.755V161.075C402.602 143.05 387.99 128.438 369.965 128.438H146.095Z",
    fill: "url(#paint0_linear_1_74)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.095 128.438C128.07 128.438 113.458 143.05 113.458 161.075V272.755C113.458 290.78 128.07 305.392 146.095 305.392H210.447C210.382 306.234 210.349 307.084 210.349 307.942V325.79C210.349 343.815 224.961 358.427 242.986 358.427H269.504C287.528 358.427 302.141 343.815 302.141 325.79V307.942C302.141 307.084 302.107 306.234 302.042 305.392H369.965C387.99 305.392 402.602 290.78 402.602 272.755V161.075C402.602 143.05 387.99 128.438 369.965 128.438H146.095Z",
    fill: "url(#paint1_linear_1_74)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.307 44.876H217.769C231.288 44.876 242.264 55.8523 242.264 69.3706V101.328H210.307C196.788 101.328 185.812 90.3515 185.812 76.8331V69.3706C185.812 55.8523 196.788 44.876 210.307 44.876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.264 214.229H274.221C287.739 214.229 298.716 225.205 298.716 238.724V246.186C298.716 259.704 287.739 270.681 274.221 270.681H266.759C253.24 270.681 242.264 259.704 242.264 246.186V214.229Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.264 101.325H293.038C306.557 101.325 317.533 112.301 317.533 125.82V133.282C317.533 146.801 306.557 157.777 293.038 157.777H242.264V101.325Z",
    fill: "#FFF7AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.49 157.777H242.264V214.229H191.49C177.971 214.229 166.995 203.253 166.995 189.734V182.272C166.995 168.753 177.971 157.777 191.49 157.777Z",
    fill: "#00BB99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.49 276.559C251.683 276.559 236.385 261.259 236.385 242.455V220.11H195.223C176.417 220.11 161.119 204.809 161.119 186.006C161.119 167.202 176.42 151.901 195.223 151.901H236.385V107.209H214.041C195.234 107.209 179.936 91.9085 179.936 73.1046C179.936 54.3008 195.237 39 214.041 39C232.845 39 248.145 54.3008 248.145 73.1046V95.4492H289.307C308.114 95.4492 323.412 110.75 323.412 129.554C323.412 148.358 308.111 163.658 289.307 163.658H248.145V208.35H270.49C289.296 208.35 304.594 223.651 304.594 242.455C304.594 261.259 289.294 276.559 270.49 276.559ZM248.145 220.108V242.452C248.145 254.773 258.169 264.797 270.49 264.797C282.811 264.797 292.834 254.773 292.834 242.452C292.834 230.131 282.811 220.108 270.49 220.108H248.145ZM195.223 163.656C182.902 163.656 172.879 173.679 172.879 186C172.879 198.321 182.902 208.345 195.223 208.345H236.385V163.653H195.223V163.656ZM248.145 151.896H289.307C301.628 151.896 311.652 141.872 311.652 129.551C311.652 117.23 301.628 107.207 289.307 107.207H248.145V151.898V151.896ZM214.038 50.7548C201.717 50.7548 191.694 60.7781 191.694 73.0993C191.694 85.4204 201.717 95.4438 214.038 95.4438H236.383V73.0993C236.383 60.7781 226.359 50.7548 214.038 50.7548Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1_74",
    x: -4,
    y: -4,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_74",
    result: "effect2_innerShadow_1_74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1_74",
    x: 46,
    y: 96,
    width: 421,
    height: 383.263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_74",
    result: "effect2_dropShadow_1_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_74",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_1_74",
    x: 82,
    y: 94,
    width: 349,
    height: 319.263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_74",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.894118 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.733333 0 0 0 0 0.6 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1_74",
    result: "effect3_innerShadow_1_74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_iii_1_74",
    x: 109.458,
    y: 124.438,
    width: 297.144,
    height: 237.989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_74",
    result: "effect2_innerShadow_1_74"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1_74",
    result: "effect3_innerShadow_1_74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_74",
    x1: 258.03,
    y1: 133.92,
    x2: 258.03,
    y2: 358.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_74",
    x1: 258.03,
    y1: 128.438,
    x2: 258.03,
    y2: 358.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inbox.81619a15.svg";
export { ForwardRef as ReactComponent };